// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"piechart-module--contentContainer--3qkN6"};